<template>
    <div class="modal">
        <div class="modal-container" v-if="features">
            <div class="modal-header relative">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Account Features</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:w-full">
                        <div class="features-body">
                            <form>
                                <div class="flex mb-3" v-for="(value, key) in features" :key="key">
                                    <input type="text" v-model="features[key]" class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline" />
                                    <button type="button" class="pl-2 text-center text-gray-500hover:text-gray-800" aria-label="Remove Feature Flag" @click="removeFeature(key)">
                                        <fa-icon icon="trash"></fa-icon>
                                    </button>
                                </div>
                                <div class="mb-3">
                                    <input type="text" v-model="newFeature" @keydown.enter.prevent="addNewFeature" placeholder="Add new feature flag (press enter to add)" class="appearance-none border w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none focus:shadow-outline" />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                        <button class="btn-primary" type="button" @click="handleFeaturesUpdate">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AccountFeatureView',
        props: {},
        components: {
            //
        },
        data() {
            return {
                features: {},
                newFeature: null,
            }
        },
        mounted() {
            this.loadData()
            this.setMetaTitle('Account Features | JournoLink Control')
        },
        methods: {
            loadData () {
                axios.get(route('accounts.features', this.$route.params.accountId))
                    .then(response => {
                        this.features = response.data.features
                    })
                    .catch(e => {
                        console.error({e})
                    })
            },
            /**
             * Handle update Feature
             */
            handleFeaturesUpdate () {
                axios.put(route('accounts.features.update', this.$route.params.accountId), {
                    features: Array.from(this.features)
                }).then(response => {
                    this.$bus.$emit('alert.success', 'Update Success')
                    this.closeView()
                })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'Update Failed')
                })
            },
            /**
             * Add a new feature to the list
             */
            addNewFeature() {
                if (_.trim(this.newFeature).length > 0 && !this.features.includes(_.trim(this.newFeature))) {
                    this.features.push(_.trim(this.newFeature))
                    this.newFeature = null
                }
            },
            /**
             * Remove a feature
             */
            removeFeature(index) {
                this.features.splice(index, 1)
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView() {
                this.$parent.loadData()
                this.$root.goBack()
            },
            /**
             * Handle an [Escape] keypress
             *
             * @return {void}
             */
            onEscapeKeypress() {
                this.closeView()
            },
        },
        computed: {
        }
    }
</script>

<style lang="less" scoped>
    .features-body {
        flex: 1;
        padding: 15px;
    }

    .vdp-datepicker {
        display: inline-block;
        border: 1px solid #dddddd;
        padding: 5px;
    }

    .modal-body {
        h2, h3 {
            text-transform: uppercase;
            font-size: 1.2em;
            letter-spacing: .08em;
            color: #34495e;
            margin-bottom: 10px;
        }
    }

    p.note {
        margin: 10px 0;
        font-weight: bold;
    }
</style>
